import { useLingui } from '@lingui/react'
import { Paper, Tabs, Tab } from '@mui/material'
import { Box, Container } from '@mui/system'
import { useState } from 'react'
import { useGetConsultationQuery } from '@/core/services/consultation'
import { TranscriptionViewer } from '@/pages/consultation/components/TranscriptionViewer'
import { ReportViewer } from '@/pages/consultation/components/ReportViewer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { skipToken } from '@reduxjs/toolkit/query/react'
import { t } from '@lingui/macro'

export default function ReportLocalConsultation({ consultationId }: { consultationId?: string }) {
  useLingui()
  const authUser = useAppSelector(selectAuthUser)
  const { data: consultation } = useGetConsultationQuery(consultationId ?? skipToken, { refetchOnMountOrArgChange: true })

  const [tabValue, setTabValue] = useState(consultation?.transcription ? 'transcription' : 'report')

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue)
  }

  return (
    <Container maxWidth="xl">
      <Box sx={{ my: 4 }}>
        <Paper sx={{ mb: 3 }}>
          <Tabs value={tabValue} onChange={handleTabChange} indicatorColor="primary" textColor="primary">
            {consultation?.transcription && <Tab label={t`Transcription`} value="transcription" />}
            {consultation?.report && <Tab label={t`Report`} value="report" />}
          </Tabs>
        </Paper>

        {tabValue === 'transcription' && consultation?.transcription && <TranscriptionViewer transcriptionId={consultation.transcription} />}

        {tabValue === 'report' && consultation?.report && <ReportViewer consultationId={consultation._id} userId={authUser?._id!} />}
      </Box>
    </Container>
  )
}
